import { render } from "./form-activities.vue?vue&type=template&id=a9af8682&ts=true"
import script from "./form-activities.vue?vue&type=script&lang=ts"
export * from "./form-activities.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__